import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-option-card',
  templateUrl: './option-card.component.html',
  styleUrls: ['./option-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionCardComponent  {

  constructor() { }

}
